<template>
  <div class="carousel-wrapper">
    <div class="carousel" :style="{ transform: `translateX(-${currentIndex * (100 / visibleItems)}%)`, width: `${visibleItems * 100}%` }">
      <div class="carousel-item" v-for="(image, index) in images" :key="index" :style="{ flex: `0 0 ${100 / visibleItems}%` }">
        <img :src="image.data" :alt="image.name" class="carousel-image" :style="getImageStyle(image)" />
      </div>
    </div>
    <button v-if="currentIndex > 0" class="prev" @click="prev">‹</button>
    <button v-if="currentIndex < images.length - visibleItems" class="next" @click="next">›</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      visibleItems: 5, // Number of visible items
      images: [
        {
          name: "Canada Geese in Sunrise",
          data: "https://media.istockphoto.com/id/1140180508/photo/two-canada-geese-in-the-light-of-the-rising-sun.jpg?s=1024x1024&w=is&k=20&c=nbC74G2JDEupwAriQ0BQU_-7DNsnS_bS6klVQTr_jEM=",
        },
        {
          name: "Greylag Goose Spreading Wings",
          data: "https://media.istockphoto.com/id/1674107129/photo/the-greylag-goose-spreading-its-wings-on-water-anser-anser-is-a-species-of-large-goose.jpg?s=1024x1024&w=is&k=20&c=Y3RWeowSnXY-gWxkTQchjXQOZ9X6Yg5fYNVVUByb5dM=",
        },
        {
          name: "Bar-Headed Goose in Forest",
          data: "https://media.istockphoto.com/id/1363559825/photo/bar-headed-goose-duck-in-the-forest.jpg?s=1024x1024&w=is&k=20&c=i3Bhsr7VRQWlZ8cE8JVu77ko9elU6FiwbrGnXjU9ATo=",
        },
        {
          name: "Bar-Headed Goose",
          data: "https://media.istockphoto.com/id/649733656/photo/bar-headed-goose.jpg?s=1024x1024&w=is&k=20&c=3bBSDmyxEtWE0LPRCrn4Xh1qlZXEUN6Ql-D1sO3kYiM=",
        },
        {
          name: "Goose by the Lake",
          data: "https://cdn.pixabay.com/photo/2024/05/05/05/55/goose-8740266_1280.jpg",
        },
        {
          name: "Canada Goose",
          data: "https://media.istockphoto.com/id/1471181605/photo/bernache-du-canada-canada-goose.jpg?s=1024x1024&w=is&k=20&c=t0utlpCEMwCB7saX7BxRJ7xk0AcPHqfIVsSwu6FnEpM=",
          preferred: true,
        },
        {
          name: "Countryside Clouds",
          data: "https://images.pexels.com/photos/236047/pexels-photo-236047.jpeg?cs=srgb&dl=clouds-cloudy-countryside-236047.jpg&fm=jpg",
        },
      ],
    };
  },
  methods: {
    next() {
      if (this.currentIndex < this.images.length - this.visibleItems) {
        this.currentIndex++;
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    getImageStyle(image) {
      if (image.preferred) {
        return {
          width: '200px',
          height: '200px',
        };
      }
      return {
        width: '100px',
        height: '100px',
      };
    },
  },
};
</script>

<style scoped>
.carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.carousel-image {
  object-fit: cover;
}

button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1000;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}
</style>
